import { createSelector } from 'reselect'
import { getSelectedFacets } from 'selectors/algolia2/data'
import { slugify } from 'lib/slugify'

export const createVisiiUrl = createSelector([getSelectedFacets], (selectedFacets) => {
  const facetNames = ['category', 'styles', 'subjects', 'mediums', 'price', 'size', 'orientation']
  const visiiUrl: string = '/vsearch'
  const searchQuery: Array<string> = []
  facetNames.forEach((facetName) => {
    const currentFacetValue = selectedFacets[facetName] || []

    if (Array.isArray(currentFacetValue)) {
      currentFacetValue.forEach((attributeValue) => {
        if (facetName === 'category' && attributeValue.search(/paintings|drawings/i) > -1) {
          // Remove trailing `s` from facet names `paintings` || `drawings`
          searchQuery.push(
            `${facetName.replace(/s$/, '')}:${slugify(attributeValue.replace(/s$/, ''))}`
          )
          return
        }

        // Remove trailing `s` from facet names to match VISII
        // Slufigy Values
        searchQuery.push(`${facetName.replace(/s$/, '')}:${slugify(attributeValue)}`)
      })
    } else {
      // We need to handle STRINGS: Ex: price => '0-500'
      searchQuery.push(
        `${facetName.replace(/s$/, '')}:${slugify(currentFacetValue.replace(/s$/, ''))}`
      )
    }
  })
  return `${visiiUrl}${searchQuery.length ? `?search=${searchQuery.join(',')}` : ``}`
})
